<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">{{ store.state.customer.shortName }}-{{ $t('nenghaokanban') }}</div>
          <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;">
              <yi_data_select :type="'organization'" :ids.sync="orgId"> </yi_data_select>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24 * (isEditingTemplate == true ? 2 : 1)" :row-height="gridRowHeihgt" :is-draggable="isEditingTemplate" :is-resizable="isEditingTemplate" :is-mirrored="false" :vertical-compact="false" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight * (isEditingTemplate == true ? 2 : 1) + 'px' }" style="overflow: hidden;">
          <grid-item @resized="resizedGrid" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component v-if="(!isEditingTemplate && item.y < 24) || isEditingTemplate" :cockpitData="cockpitData" :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import device_seven_top5 from '@@/pages/web/monitor/energy/device_seven_top5';
import device_thirty_top5 from '@@/pages/web/monitor/energy/device_thirty_top5';
import device_seven_trend from '@@/pages/web/monitor/energy/device_seven_trend';
import device_thirty_ratio from '@@/pages/web/monitor/energy/device_thirty_ratio';
import device_today_ratio from '@@/pages/web/monitor/energy/device_today_ratio';
import sum from '@@/pages/web/monitor/energy/sum';
export default {
  name: 'web_monitor_energy_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    device_seven_top5: device_seven_top5,
    device_thirty_top5: device_thirty_top5,
    device_seven_trend: device_seven_trend,
    device_today_ratio: device_today_ratio,
    device_thirty_ratio: device_thirty_ratio,

    sum: sum
  },

  data() {
    return {
      isEditingTemplate: false,
      isShowBoardEdit: false,
      orgId: this.store.state.organizations[0].id,
      cockpitData: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: []
    };
  },
  watch: {
    orgId(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getCockpit();
    }
  },
  created() {
    this.setLayout();

    this.timmer = setInterval(() => {
      this.getCockpit();
    }, 600000);
    this.getCockpit();
  },
  activated() {
    this.resize();
  },
  mounted() {

    this.resize();
    this.utils.event_hub.$on('SetLayoutCockpit', () => {
      this.setLayout();
    });
    this.utils.event_hub.$on('BeginEditCockpit', () => {
      this.isEditingTemplate = true;
      this.isShowBoardEdit = false;
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    this.utils.event_hub.$off('SetLayoutCockpit');
    this.utils.event_hub.$off('BeginEditCockpit');

    if (this.timmer) {
      clearInterval(this.timmer);
    }
  },
  methods: {
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING'));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_ENERGY_TEMPLATE == null) {
        this.monitorSetting.MONITOR_ENERGY_TEMPLATE = 'moren';
      }
      if (this.monitorSetting.MONITOR_ENERGY_TEMPLATES == null) {
        this.monitorSetting.MONITOR_ENERGY_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 6,
              h: 12, //应该是6
              i: 'device_seven_top5'
            },
            {
              x: 6,
              y: 0,
              w: 12,
              h: 12, //应该是6
              i: 'sum'
            },
            {
              x: 18,
              y: 0,
              w: 6,
              h: 12,
              i: 'device_today_ratio'
            },
            {
              x: 0,
              y: 12,
              w: 6,
              h: 12, //应该是6
              i: 'device_thirty_top5'
            },
            {
              x: 6,
              y: 12,
              w: 12,
              h: 12, //应该是6
              i: 'device_seven_trend'
            },
            {
              x: 18,
              y: 12,
              w: 6,
              h: 12, //应该是6
              i: 'device_thirty_ratio'
            }
          ]
        };
      }

      this.layout = this.monitorSetting.MONITOR_ENERGY_TEMPLATES[this.monitorSetting.MONITOR_ENERGY_TEMPLATE];
      this.$nextTick(() => {
        this.utils.event_hub.$emit('RESIZE');
      });
    },
    async getCockpit() {
      let response = await this.http.get('/web/energy/consumption/data/board/dataSummary', {
        params: {
          orgId: this.orgId
        }
      });
      const data1 = response.data;
      const sum = {
        thanLastMonthSameDateEle: data1.thanLastMonthSameDateEle.toFixed(1),
        thanLastYearSameDateEle: data1.thanLastYearSameDateEle.toFixed(1),
        thanThirtyDayAverageEle: data1.thanThirtyDayAverageEle.toFixed(1),
        theMonthTotalEle: data1.theMonthTotalEle.toFixed(1),
        theYearTotalEle: data1.theYearTotalEle.toFixed(1),
        yesterdayTotalEle: data1.yesterdayTotalEle.toFixed(1)
      };
      this.$set(this.cockpitData, 'sum', sum);

      let response2 = await this.http.get('/web/energy/consumption/data/board/top5In7', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'top5In7', response2.data);

      let response3 = await this.http.get('/web/energy/consumption/data/board/top5In30', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'top5In30', response3.data);

      let response4 = await this.http.get('/web/energy/consumption/data/board/top5InToday', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'top5InToday', response4.data);

      let response5 = await this.http.get('/web/energy/consumption/data/board/trendIn7', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'trendIn7', response5.data);
    },

    resizedGrid(i) {
      this.$refs['grid_' + i][0].resize();
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;

        for (let index = 0; index < this.layout.length; index++) {
          let layout = this.layout[index];
          this.resizedGrid(layout.i);
        }
      }, 500);
    }
  }
};
</script>
